const semanticTokens = {
  colors: {
    divider: {
      'default': 'blackAlpha.200',
      _dark: 'whiteAlpha.200',
    },
    text: {
      'default': 'blackAlpha.800',
      _dark: 'whiteAlpha.800',
    },
    text_secondary: {
      'default': 'gray.500',
      _dark: 'gray.400',
    },
    link: {
      'default': 'green.500',
      _dark: 'blue.300',
    },
    link_hovered: {
      'default': 'green.400',
      _dark: 'blue.300',
    },
    icon_link_external: {
      'default': 'gray.300',
      _dark: 'gray.500',
    },
    icon_info: {
      'default': 'gray.400',
      _dark: '#999999',
    },
    error: {
      'default': 'red.500',
      _dark: 'red.500',
    },
    dialog_bg: {
      'default': 'white',
      _dark: 'gray.900',
    },
    // BOT explorer / Figma contract verification (light + dark)
    form_input_bg: {
      'default': '#FFFFFF',
      _dark: '#111111',
    },
    form_input_border: {
      'default': '#E8E8E8',
      _dark: '#222222',
    },
    form_input_fg: {
      'default': '#0A0A0A',
      _dark: '#FFFFFF',
    },
    form_input_placeholder: {
      'default': '#999999',
      _dark: '#999999',
    },
    form_input_focus: {
      'default': '#14DCAC',
      _dark: '#14DCAC',
    },
    form_upload_zone_bg: {
      'default': '#FFFFFF',
      _dark: '#111111',
    },
    form_upload_inner_bg: {
      'default': '#FAFAFA',
      _dark: '#171717',
    },
    form_upload_inner_border: {
      'default': '#E8E8E8',
      _dark: '#222222',
    },
    form_upload_accent: {
      'default': '#14DCAC',
      _dark: '#14DCAC',
    },
    verification_submit_bg: {
      'default': '#14DCAC',
      _dark: '#14DCAC',
    },
    verification_submit_fg: {
      'default': '#000000',
      _dark: '#000000',
    },
  },
  shadows: {
    action_bar: '0 4px 4px -4px rgb(0 0 0 / 10%), 0 2px 4px -4px rgb(0 0 0 / 6%)',
  },
};

export default semanticTokens;
